/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { badgeStyle } from './Badge.styles';

/** 색 계열. admin-mockup의 enabled/RUNNING/FAILED/QUEUED 류 pill에서 추출. */
export type BadgeTone = 'neutral' | 'success' | 'danger' | 'info' | 'secondary';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
}

/** 상태 표시 배지. 모듈 enabled 표시, Job 상태(RUNNING·SUCCESS·FAILED·QUEUED)에 활용. */
export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span css={badgeStyle(tone)}>{children}</span>;
}
